<template>
    <div>
        <div v-if="!pmp_case_details" v-loading="true" class="p-5"></div>
        <div class="property-details" v-if="pmp_case_details">
            <ReturnUnitModal ref="returnUnitModal" :product="product"/>
            <ChangeUnitModal ref="changeUnitModal" :product="product" :pmp_case_details="pmp_case_details"/>
            <AdditionalRebateModal ref="additionalRebateModal" :product="product" :pmp_case_details="pmp_case_details"/>
            <div class="mb-3" v-if="!['Cancelled', 'Revoke'].includes(product.prod_main_status)">
                <el-button class="bg-danger text-white p-2" @click="$refs.returnUnitModal.toggleView()">Return Unit</el-button>
                <el-button class="bg-orange text-white p-2" 
                    @click="$refs.changeUnitModal.toggleView()"
                    v-if="_gHlp.checkRoleType(['corporate', 'admin', 'manager'])"    
                >Change Unit</el-button>
                <el-button class="bg-dark outline-none text-white p-2" 
                    @click="$refs.additionalRebateModal.toggleView()"
                    v-if="pmp_case_details.settings.cb_add_percent_to_customer && pmp_case_details.settings.cb_add_percent_to_customer > 0"
                >
                    <span v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check === null">
                        <b-icon icon="clock" class="text-warning mr-1"></b-icon>
                    </span>
                    <span v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check == 1">
                        <b-icon icon="check" scale="1.5" class="text-success mr-1"></b-icon>
                    </span>
                    <span v-if="pmp_case_details.additional_info.additional_rebate_approval.approval_check == 0">
                        <b-icon icon="x" scale="1.5" class="text-danger mr-1"></b-icon>
                    </span>
                    Request Additional {{ pmp_case_details.settings.cb_add_percent_to_customer }}% Rebate
                </el-button>
                <div class="m-2 badge badge-primary" v-if="product.product_detail.prod_pm_property_src != 'HESTIA'">PMP</div>
                <div class="m-2 badge badge-warning" v-else>HESTIA</div>
            </div>
            <div class="d-flex align-items-center">
                <el-image
                    v-if="product.product_detail.prod_pm_property_src != 'HESTIA'"
                    style="width: 100px; height: 80px"
                    class="rounded mr-3"
                    :src="product.prod_image_url"
                    fit="cover">
                </el-image>
                <el-image
                    v-else
                    style="width: 100px; height: 80px"
                    class="rounded mr-3"
                    :src="cover_image"
                    fit="cover">
                </el-image>
                <b-row>
                    <b-col cols="12">
                        <div class="d-flex align-items-center">
                            <p class="font-weight-500">{{ product.product_detail.prod_pm_project_name }}</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256"><path fill="#73839C" d="M156 128a28 28 0 1 1-28-28 28 28 0 0 1 28 28Z"/></svg>
                            <p class="font-weight-500">{{ product.product_detail.prod_pm_unit_no }}</p>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <b-row>
                            <b-col>
                                <p>SPA Price</p>
                                <p>RM{{ product.product_detail.prod_pm_spa_price | moneyFormatter }}</p>
                            </b-col>
                            <b-col>
                                <p>Cashback</p>
                                <p>RM{{ product.product_detail.prod_pm_cashback | moneyFormatter }}</p>
                            </b-col>
                            <b-col>
                                <p>Net Buyer Discount</p>
                                <p>RM{{ product.product_detail.prod_pm_net_buyer_discount | moneyFormatter }}</p>
                            </b-col>
                            <b-col>
                                <p>Buyer Discount</p>
                                <p>{{ product.product_detail.prod_pm_buyer_discount }}%</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12">
                        <div v-b-toggle.collapse-1 class="cursor-pointer">
                            View more details
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-collapse id="collapse-1" class="mt-2">
                <div class="border rounded p-3 more-details">
                    <b-row>
                        <b-col cols="4" class="border-right">
                            <div class="mb-3">
                                <p class="text-xs">Property Type</p>
                                <p>{{ product.product_detail.prod_pm_property_type }}</p>
                            </div>
                            <div class="mb-3">
                                <p class="text-xs">Lease Type</p>
                                <p>{{ product.product_detail.prod_pm_lease_type }}</p>
                            </div>
                            <div class="mb-3">
                                <p class="text-xs">SQFT</p>
                                <p>{{ product.product_detail.prod_pm_property_size }}</p>
                            </div>
                            <div class="mb-3">
                                <p class="text-xs">Benefits</p>
                                <p v-if="product.product_detail.prod_pm_benefits">{{ product.product_detail.prod_pm_benefits }}</p>
                                <p v-else>N/A</p>
                            </div>
                        </b-col>
                        <b-col cols="8">
                            <b-row>
                                <b-col cols="12">
                                    <p class="font-weight-500">Fee Estimation</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs">S&P Agreement Fees</p>
                                    <p>RM{{ product.product_detail.prod_pm_sp_agreement_fee | moneyFormatter }}</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs">MOT</p>
                                    <p>RM{{ product.product_detail.prod_pm_mot_fees | moneyFormatter  }}</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs">Loan Agreement Fees</p>
                                    <p>RM{{ product.product_detail.prod_pm_loan_agreement_fees | moneyFormatter  }}</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs">Maintenance Fee (Monthly)</p>
                                    <p>RM{{product.product_detail.prod_pm_maintenance_fees | moneyFormatter }}</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs">Loan Stamp Duty</p>
                                    <p>RM{{ product.product_detail.prod_pm_loan_stamp_duty | moneyFormatter  }}</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs">Sinking Fund (Monthly)</p>
                                    <p>RM{{ product.product_detail.prod_pm_sinking_fund | moneyFormatter  }}</p>
                                </b-col>
                                <b-col cols="6" class="mb-3">
                                    <p class="text-xs font-weight-bold">Total Fees</p>
                                    <p>RM{{ product.product_detail.prod_pm_total_fees | moneyFormatter  }}</p>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </b-collapse>
        </div>
    </div>
</template>
<script>
import { Image, Button } from 'element-ui'
import ReturnUnitModal from './Modals/ReturnUnitModal.vue'
import ChangeUnitModal from './Modals/ChangeUnitModal.vue'
import AdditionalRebateModal from './Modals/AdditionalRebateModal.vue'

import {
        helperFunctionMixin,
    } from '@/assets/js/httpImports.js'

export default {
    props: ['product', 'pmp_case_details', 'cover_image'],
    mixins: [helperFunctionMixin],
    components: {
        AdditionalRebateModal,
        ReturnUnitModal,
        ChangeUnitModal,
        [Image.name]: Image,
        [Button.name]: Button,
    },
}
</script>